import { render, staticRenderFns } from "./dialog-demande-validation-fiche-aim.vue?vue&type=template&id=06a4c014"
import script from "./dialog-demande-validation-fiche-aim.vue?vue&type=script&setup=true&lang=js"
export * from "./dialog-demande-validation-fiche-aim.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports